/* RunRun 2026-09-01 (DM MX) — Apple Pay solo, en el carrito, cuando el dispositivo lo soporta.
 *
 * v2 (misma fecha): en vez de ocultar a los hermanos con display:none (que dejaba el boton
 * de Apple Pay encerrado en una celda de media anchura dentro del shadow DOM cerrado de
 * <shopify-accelerated-checkout-cart>), se REEMPLAZA el host por un clon cuyo `wallet-configs`
 * solo trae apple_pay y cuyo unico hijo slotted es el boton de Apple. Con una sola wallet,
 * Shopify renderiza el boton a ancho completo (verificado con shop_pay en Chromium: 164px -> 339px
 * y el clic sigue abriendo el flujo). Radio y alto se controlan con las custom properties
 * oficiales (--shopify-accelerated-checkout-button-border-radius / -block-size) desde cart-summary.liquid.
 *
 * Regla de seguridad: NO se toca nada salvo que exista de verdad un boton de Apple Pay
 * renderizado Y el navegador declare que puede pagar con el. En Chrome, Android o cualquier
 * navegador sin ApplePaySession el script no toca el DOM. "Ir a pagar" siempre sigue arriba,
 * y el checkout hospedado sigue ofreciendo Shop Pay y Google Pay.
 *
 * Rollback: borrar este asset y su <script> en layout/theme.liquid.
 */
(function () {
  if (window.__rrExpressWallets) return;
  window.__rrExpressWallets = true;

  var HOSTS = 'shopify-accelerated-checkout-cart';
  var KEEP = /apple/i;

  function applePayUsable() {
    try {
      return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments());
    } catch (e) {
      return false;
    }
  }

  function keepOnly(host, pattern) {
    if (host.hasAttribute('data-rr-apple-only')) return;
    var kids = Array.prototype.slice.call(host.children);
    var keep = kids.filter(function (el) { return pattern.test(el.tagName); });
    if (!keep.length) return; // sin boton de Apple renderizado, no se toca
    var cfg;
    try { cfg = JSON.parse(host.getAttribute('wallet-configs') || '[]'); } catch (e) { cfg = []; }
    var only = cfg.filter(function (c) { return pattern.test(c && c.name ? c.name : ''); });
    if (!only.length) return; // el config no trae apple_pay: no se toca
    var clone = host.cloneNode(false);
    clone.setAttribute('wallet-configs', JSON.stringify(only));
    clone.setAttribute('data-rr-apple-only', '');
    keep.forEach(function (el) { clone.appendChild(el.cloneNode(true)); });
    host.replaceWith(clone);
  }

  function apply(pattern) {
    document.querySelectorAll(HOSTS).forEach(function (host) { keepOnly(host, pattern); });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; if (applePayUsable()) apply(KEEP); }, 150);
  }

  function boot() {
    if (applePayUsable()) apply(KEEP);
    // El drawer del carrito se re-renderiza (morph) en cada alta/baja de linea:
    // hay que reaplicar cuando reaparece el host original. Con debounce.
    var mo = new MutationObserver(schedule);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    ['cart:update', 'cart:refresh', 'variant:update'].forEach(function (ev) {
      document.addEventListener(ev, schedule);
    });
    [300, 900, 2000, 4000].forEach(function (ms) { setTimeout(function () { if (applePayUsable()) apply(KEEP); }, ms); });
  }

  // Gancho de prueba (sin Apple Pay real): window.__rrExpressWalletsKeep(/shop/i)
  window.__rrExpressWalletsKeep = function (re) { apply(re || KEEP); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
